import AemButton from '@/components/Aem/AemButton';
import {ArrowSmallIcon} from '@/components/Icons';
import useIsMobileLayout from '@/hooks/layout/useIsMobileLayout';
import amplitudeLoyaltyTracking from '@/services/analytics/amplitude/amplitudeLoyaltyTracking';
import googleAnalyticsService from '@/services/analytics/ga/googleAnalyticsService';
import appContent from '@/services/content/appContent';
import appRouterService from '@/services/route/appRouterService';
import {twx} from '@/utils/tailwindUtils';

import BadgeItem from './BadgeItem';

const EarnBadges = ({availableJourneys}) => {
    const isMobile = useIsMobileLayout();
    const badgesCount = isMobile ? 2 : 3;
    const journeysToDisplay = availableJourneys.slice(0, badgesCount);
    const content = appContent.getBadgesListContent();
    const {title, viewAllButton, backgroundImage, learnMoreButton, externalLink} = content;
    const isSingleBadge = journeysToDisplay.length === 1;

    const onViewAllClick = () => {
        amplitudeLoyaltyTracking.trackViewAllButtonClick();
        googleAnalyticsService.trackViewAllButtonClick();
        appRouterService.forwardToLoyaltyPage();
    };

    return (
        <>
            <div className='flex items-center justify-between gap-4'>
                <h2 className='m-0 truncate text-start text-24 font-bold md:text-28 lg:text-32'>{title}</h2>
                <AemButton className='shrink-0' raw onClick={onViewAllClick} {...viewAllButton}>
                    <ArrowSmallIcon />
                </AemButton>
            </div>
            <div
                className={twx(
                    'mt-4 grid grid-cols-2 gap-2 ml:grid-cols-3 ml:gap-4',
                    isSingleBadge && 'grid-cols-1 md:grid-cols-2'
                )}
                role='list'
            >
                {journeysToDisplay.map((journey, index) => (
                    <BadgeItem
                        key={index}
                        badge={journey.journeyLevels?.[0]?.journeyBadge ?? null}
                        backgroundImage={backgroundImage}
                        learnMoreButton={learnMoreButton}
                        externalLink={externalLink}
                    />
                ))}
            </div>
        </>
    );
};

export default EarnBadges;
